import { graphql } from '../../gql';

export const RICS_SELECTION_LIST = graphql(`
  query RicsSelectionList {
    selectionList {
      rics_k400 {
        id
        shortName
        longName
        rics_k10
        rics_k50
        headcount
      }
    }
  }
`);
